import { render, staticRenderFns } from "./collegeBanner.vue?vue&type=template&id=22a6210f&scoped=true&"
import script from "./collegeBanner.vue?vue&type=script&lang=js&"
export * from "./collegeBanner.vue?vue&type=script&lang=js&"
import style0 from "./collegeBanner.vue?vue&type=style&index=0&id=22a6210f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6210f",
  null
  
)

export default component.exports